import { Router, ActivatedRoute, NavigationStart } from '@angular/router'
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core'
import { filter } from 'rxjs/operators'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { getPropertyState } from '@containers/properties/properties.selectors'

@Component({
  selector: 'property-tabs',
  templateUrl: './property-tabs.component.html',
  styleUrls: ['./property-tabs.component.css'],
})
export class PropertyTabsComponent implements OnInit, OnDestroy {
  public router$: Subscription
  public tab: string
  public hasDocumentsTab: boolean
  @Input() public propertyStatus: string
  @Output() public tabChanged: EventEmitter<any> = new EventEmitter()
  public state: any
  public propertyData: any
  public state$: Subscription

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getPropertyState))
      .subscribe((state) => {
        this.state = state.toJS()
        this.propertyData = !!this.state.data.propertyCodeAssigned && {
          propertyCodeAssigned: this.state.data.propertyCodeAssigned,
          status: this.state.data.status,
          propertyCodeExternal: this.state.data.propertyCodeExternal,
          address:
            this.state.data.building?.street &&
            `${this.state.data.building?.street?.name ?? ''} ${
              this.state.data.building?.streetNumber ?? ''
            }`,
          plusCode: this.state.data.building?.plusCode,
        }
      })

    let split = this.router.url.split('/')
    this.tab = split[split.length - 1]
    this.hasDocumentsTab = split[2] !== 'create'
    this.router$ = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(({ url }: any) => {
        split = url.split('/')
        this.tab = split[split.length - 1]
      })
  }
  changeTab(tab: Array<string>) {
    this.tabChanged.emit(tab)
  }
  ngOnDestroy() {
    this.router$.unsubscribe()
    this.state$.unsubscribe()

    this.propertyData = null
  }
}
